const autoNgTemplateLoaderTemplate1 = require('./theme-settings.html');

import angular from 'angular';
import controller from './theme-settings.controller';

angular.module('portainer.app').component('themeSettings', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
});
